import React, { useEffect } from 'react';

import Breadcrumbs from '@/components/common/Breadcrumbs';
import MaxWidth from '@/components/common/layout/MaxWidth';
import LinkList from '@/components/common/ui/LinkList';
import { trackEvent } from '@/services/track-event';

import css from './ParkGuideDirectoryTemplate.module.css';

const RentalDirectoryTemplate = ({ metadata: { title, breadcrumbs, links } } = {}) => {
  useEffect(() => {
    trackEvent({
      event: 'Locality : Viewed page',
      pageType: 'Rental directory',
    });
  }, []);

  return (
    <div className={css.parkDirectoryContainer}>
      <MaxWidth className="py-4">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </MaxWidth>

      <MaxWidth className="mb-8">
        <h2 className="mb-4">{title}</h2>
        <LinkList links={links} />
      </MaxWidth>
    </div>
  );
};

export default RentalDirectoryTemplate;
